import * as React from 'react';

import ReferralWheel from './ReferralWheel';

const App = () => {
  return <ReferralWheel />;
};

export default App;
